import {
  CollaboratorModel,
  DepartmentModel,
  BranchModel,
  IdeaModel,
} from "./../model/BrainstormModel";
import { Injectable } from "../../node_modules/@angular/core";
import {
  HttpClient,
  HttpHeaders,
} from "../../node_modules/@angular/common/http";
import { Observable } from "../../node_modules/rxjs";

import { environment } from "../environments/environment";

@Injectable()
export class BrainstormService {
  constructor(private http: HttpClient) {}

  public listBranches(clientId: number): Observable<Array<BranchModel>> {
    return this.http.get<Array<BranchModel>>(
      environment.apiHost +
        "/organograma/administracao/unidade/list/client/" +
        clientId
    );
  }

  public listDepartments(branchId: number): Observable<Array<DepartmentModel>> {
    return this.http.get<Array<DepartmentModel>>(
      environment.apiHost +
        "/organograma/administracao/departamento/unidade/" +
        branchId
    );
  }

  public listCollaborators(
    departmentId: number
  ): Observable<Array<CollaboratorModel>> {
    return this.http.get<Array<CollaboratorModel>>(
      environment.apiHost +
        "/organograma/administracao/colaborador/departamento/" +
        departmentId
    );
  }

  public getCollaborator(
    collaboratorId: number
  ): Observable<CollaboratorModel> {
    return this.http.get<CollaboratorModel>(
      environment.apiHost +
        "/organograma/administracao/colaborador/" +
        collaboratorId
    );
  }

  public listImplementerIdeas(userId: number): Observable<Array<IdeaModel>> {
    return this.http.get<Array<IdeaModel>>(
      environment.apiHost + "/ideia/list/implementador/" + userId
    );
  }

  public listCollaboratorIdeas(userId: number): Observable<Array<IdeaModel>> {
    return this.http.get<Array<IdeaModel>>(
      environment.apiHost + "/ideia/list/usuario/" + userId
    );
  }

  public getIdea(ideaId: number): Observable<IdeaModel> {
    return this.http.get<IdeaModel>(
      environment.apiHost + "/ideia/formulario/" + ideaId
    );
  }

  public saveIdea(data: IdeaModel): Observable<IdeaModel> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http
      .post(environment.apiHost + "/ideia/save", JSON.stringify(data), {
        headers: headers,
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public saveFile(fileData: File, model: IdeaModel): Observable<IdeaModel> {
    let inputData = new FormData();
    inputData.append("file", fileData, fileData.name);
    inputData.append("ideia", JSON.stringify(model));
    return this.http
      .post(environment.apiHost + "/ideia/upload/s3", inputData, {
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }
}



// WEBPACK FOOTER //
// ./src/services/BrainstormService.ts